module.exports = __webpack_public_path__ + "img/map_3.d44332cf.webp";